module.exports = __webpack_public_path__ + "static/media/CredTECNew.a6050288.svg";